import { PropsWithChildren, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../lib/hooks.ts';

interface RequiresFeatureProps extends PropsWithChildren {
    feature: Features
}

// eslint-disable-next-line react-refresh/only-export-components
export enum Features {
    PARKING = "hasParking"
}

export default function RequiresFeature({children, feature}: RequiresFeatureProps) {
    const selectedBuilding = useAppSelector(state => state.building.building)
    const navigate = useNavigate();

    let hasFeature: boolean | undefined

    switch (feature) {
        case Features.PARKING:
            hasFeature = selectedBuilding?.features.hasParking
            break;
        default:
            hasFeature = undefined
    }

    hasFeature = hasFeature ?? false

    useEffect(() => {
        if (!hasFeature) {
            navigate("/overview")
        }
    }, [selectedBuilding, hasFeature, navigate]);

    if (hasFeature) {
        return children
    } else {
        return (
            <div/>
        )
    }
}